import * as type from '../../shared/action.event';
import { EventListenerService } from '../../services/close-listenenr.service';

export class NavMenu {

    constructor(protected closeService: EventListenerService) { }

    close() {
        this.closeService.closeEvent(type.SETTING_PAGE);
    }
}
